import { type GenericListQueryKey, generateInfiniteQueryKey, generateListQueryKey } from '@pba/react-query';
import type { AssetsSorter } from '../types';

export const assetsFeatureKey = ['assets'] as const;

export type AssetsQueryFilter = {
  communityId?: string;
  parentId?: string;
  programId?: string;
};

export type AssetsQuerySorter = AssetsSorter;

type AssetsListQueryType = GenericListQueryKey<AssetsQueryFilter, AssetsQuerySorter>;

const getAssetsListQueryKey = ({ filter, pagination, sorter }: AssetsListQueryType) =>
  generateListQueryKey({
    prefix: assetsFeatureKey,
  })({ filter, pagination, sorter });

export const getAssetsInfiniteQueryKey = generateInfiniteQueryKey({
  generateListQueryKey: getAssetsListQueryKey,
});
